module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_3016.bcc84fa5.png";